(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-product-card"] && !Shopify.designMode) return;
  try {
    // Ensure quick-add button clicks don't trigger the card link
  document.addEventListener('DOMContentLoaded', function() {
    const quickAddWrappers = document.querySelectorAll('.collection-product-card__quick-add-wrapper');
    
    quickAddWrappers.forEach(wrapper => {
      wrapper.addEventListener('click', function(e) {
        // Stop event from bubbling to the card link
        e.stopPropagation();
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
